import {Component, EventEmitter, Input, input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";

@Component({
  selector: 'configuration-input-field',
  imports: [
    FormsModule,
    NgClass
  ],
  templateUrl: './input-field.component.html',
  styleUrl: './input-field.component.scss'
})
export class InputFieldComponent {
  @Input() label: string = "Label";
  @Input() placeholder: string = "Placeholder";
  @Input() id: string = "input-field";
  @Input() name: string = "input-field";
  @Input() autocomplete: string | undefined;
  @Input() validationPattern: string | undefined;
  @Input() required: boolean = false;
  @Input() type: string = "text";
  @Input() readonly: boolean = false;
  @Input() hasButton: boolean = false;
  @Input() buttonText: string = "Button";
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  @Input() hasContent: boolean = true;

  /**
   * Optional helper text shown under the field. It is rendered with the id `<id>-hint` and wired to the input
   * through `aria-describedby`, so a screen reader reads it with the field instead of somewhere after it. Empty
   * or unset renders nothing, which keeps every existing caller unchanged.
   */
  readonly hint = input<string | undefined>();

  @Input() value: string = "";
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  protected get hintId(): string | null {
    return this.hint() ? `${this.id}-hint` : null;
  }

  get isValid(): boolean {
    if (!this.validationPattern) return true;
    const regex = new RegExp(this.validationPattern);
    return regex.test(this.value);
  }

  onChange($event: string) {
    this.value = $event;
    this.valueChange.emit(this.value);
  }
}
